import { render, staticRenderFns } from "./ProgramModuleActivityCreateDetail.vue?vue&type=template&id=2c6d2006"
import script from "./ProgramModuleActivityCreateDetail.vue?vue&type=script&lang=js"
export * from "./ProgramModuleActivityCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleActivityCreateDetail.vue?vue&type=style&index=0&id=2c6d2006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports